import types from "./actionTypes";

export function updateNavOnLoggedInDetailsSuccess(loggedInUserDetails) {
	return {
		type: types.UPDATE_NAV_AFTER_LOGIN_DETAILS_SUCCESS,
		loggedInUserDetails,
	};
}